import React, { useEffect, useRef } from 'react';
import { EmptyErrorState } from '@nebula/empty-error-state';
import { ErrorIcon, iconSizes } from '@nebula/icons/ui';
import { errorMessages } from '../../../../constants';
import styled from 'styled-components';
import {
  ChangePaymentMethodStage,
  changePaymentMethodTransition,
  isFlutterApp,
} from '@ecs-uk/web-common-mobile-view-helpers';

const StyledEmptyErrorState = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const CPMErrorStatus: React.FC = () => {
  const errorContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isFlutterApp()) {
      changePaymentMethodTransition({
        stage: ChangePaymentMethodStage.serviceUnavailable,
      });
    }

    // Focus on the error container when it mounts for accessibility
    if (errorContainerRef.current) {
      errorContainerRef.current.focus();
    }
  }, []);

  return (
    <StyledEmptyErrorState ref={errorContainerRef} tabIndex={-1}>
      <EmptyErrorState
        header={errorMessages.changePayment.header}
        icon={<ErrorIcon iconSize={iconSizes.large} />}
        paragraph={errorMessages.changePayment.message}
      />
    </StyledEmptyErrorState>
  );
};

export default CPMErrorStatus;
